import { render, staticRenderFns } from "./FeedbackSlide.vue?vue&type=template&id=f834ad98&lang=pug"
import script from "./FeedbackSlide.vue?vue&type=script&lang=ts"
export * from "./FeedbackSlide.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackSlide.vue?vue&type=style&index=0&id=f834ad98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports